import styled from '@emotion/styled'
import { NegotiationActions, NegotiationDetail } from 'api'
import { Locale, Translation } from 'locale'
import { noop } from 'lodash'
import React, { useCallback } from 'react'
import { useSelector, useDispatch, Selector } from 'react-redux'
import { serverClientTimeOffsetSelector } from 'selectors/timeSelectors'
import { GlobalState } from 'store'
import { getValidUntilTime } from 'utils'
import { SplitButton, SplitButtonType } from 'view/components/menus'
import { canSend } from '../../../shared/utils'

const ButtonWrapper = styled.div`
  display: flex;
  padding-right: 5px;
`
interface QuotePricedNegotiationsButton {
  negotiationsSelector: Selector<GlobalState, NegotiationDetail[]>
  onClick?: () => void
}

export const QuotePricedNegotiationsButton: React.FC<QuotePricedNegotiationsButton> = ({ negotiationsSelector, onClick = noop }) => {
  const negotiations = useSelector(negotiationsSelector).filter(canSend)
  const serverClientTimeOffset = useSelector(serverClientTimeOffsetSelector)
  const dispatch = useDispatch()

  const onSend = useCallback(() => {
    negotiations.forEach(negotiationDetail => {
      dispatch(
        NegotiationActions.quote(
          negotiationDetail.negotiation.negotiationId,
          negotiationDetail.ownOrder,
          getValidUntilTime(serverClientTimeOffset, negotiationDetail.otwDuration),
          negotiationDetail.otwDuration === 0
        )
      )
    })
    onClick()
  }, [dispatch, negotiations, onClick, serverClientTimeOffset])

  return negotiations.length > 0 ? (
    <ButtonWrapper>
      <SplitButton onClick={onSend} type={SplitButtonType.Primary}>
        {`${Locale.translate(Translation.TC_SEND_ALL)} (${negotiations.length})`}
      </SplitButton>
    </ButtonWrapper>
  ) : null
}
